import * as types from '../constants/idpAdminActions';
import {logoutApi} from "../api/api";

export const logoutStart = () => ({
  type: types.LOGOUT_START
});
export const logoutSuccess = () => ({
  type: types.LOGOUT_SUCCESS
});
export const logoutFail = (errorMsg) => ({
  type: types.LOGOUT_FAIL,
  errorMsg,
});

export function logout() {
  return dispatch => {
    dispatch(logoutStart());
    return logoutApi()
    .then(response => {
      dispatch(logoutSuccess());
    })
    .catch((error) => {
      dispatch(logoutFail(error.message));
    })
  }
}
